import { render } from "./FormatAlignJustify.vue?vue&type=template&id=52aa3644"
import script from "./FormatAlignJustify.vue?vue&type=script&lang=js"
export * from "./FormatAlignJustify.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/FormatAlignJustify.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52aa3644"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52aa3644', __exports__)) {
    api.reload('52aa3644', __exports__)
  }
  
  module.hot.accept("./FormatAlignJustify.vue?vue&type=template&id=52aa3644", () => {
    api.rerender('52aa3644', render)
  })

}


export default __exports__